import { AuthPageHeader } from '../../Auth.styles';
import { ILoginPageHeader } from './types';

export const LoginUserPassPageHeader = ({ translate }: ILoginPageHeader) => (
  <AuthPageHeader>
    <h2>{translate('AUTH.LOGIN')}</h2>
    <p>{translate('AUTH.ENTER_YOUR_EMAIL_AND_PASSWORD')}</p>
  </AuthPageHeader>
);
